export const GQT_ACCOUNTING = 'GQT_ACCOUNTING';
export const GQT_AIR = 'GQT_AIR';
export const GQT_CRUISE = 'GQT_CRUISE';
export const GQT_INCENTIVE = 'GQT_INCENTIVE';
export const GQT_ADMIN = 'GQT_SADMIN';
export const GQT_COORDINATOR = 'GQT_COORDINATOR';
export const GQT_REVENUE = 'GQT_REVENUE';
export const GQT_COMMERCIAL = 'GQT_COMMERCIAL';
export const GQT_SUPERVISOR = 'GQT_SUPERVISOR';
export const GQT_MARKETING = 'GQT_MARKETING';
export const GQT_SUPPORT = 'GQT_SUPPORT';
export const GQT_ASM = 'GQT_ASM';
export const GQT_TAGENT = 'b2b';

export const HOTEL_ONLY = 'HOTEL_ONLY';
export const PACKAGE = 'PACKAGE';
export const AIR_ONLY = 'AIR_ONLY';
export const CRUISE = 'CRUISE';
export const MULTI_TOURS = 'MULTI_TOURS';
export const TOUR = 'TOUR';
export const MDT = 'MDT';
export const AIR = 'AIR';
export const HOTEL = 'HOTEL';
export const INCENTIVES = 'INCENTIVES';

export const QT_ACCOUNTING = 'ACCOUNTING';
export const QT_AIR = 'AO';
export const QT_CRUISE = 'CR';
export const QT_INCENTIVE = 'IN';
export const QT_COORDINATOR = 'CO';
export const QT_REVENUE = 'RM';
export const QT_COMMERCIAL = 'GC';
export const QT_SUPERVISOR = 'SU';

export const MAP_DEPARTMENT_TO_ROLE = {
  [QT_ACCOUNTING]: GQT_ACCOUNTING,
  [QT_AIR]: GQT_AIR,
  [QT_CRUISE]: GQT_CRUISE,
  [QT_INCENTIVE]: GQT_INCENTIVE,
  [QT_COORDINATOR]: GQT_COORDINATOR,
  [QT_REVENUE]: GQT_REVENUE,
  [QT_COMMERCIAL]: GQT_COMMERCIAL,
  [QT_SUPERVISOR]: GQT_SUPERVISOR
};

export const MAP_ROLE_TO_DEPARTMENT = {
  [GQT_ACCOUNTING]: QT_ACCOUNTING,
  [GQT_AIR]: QT_AIR,
  [GQT_CRUISE]: QT_CRUISE,
  [GQT_INCENTIVE]: QT_INCENTIVE,
  [GQT_COORDINATOR]: QT_COORDINATOR,
  [GQT_REVENUE]: QT_REVENUE,
  [GQT_COMMERCIAL]: QT_COMMERCIAL,
  [GQT_SUPERVISOR]: QT_SUPERVISOR,
  [GQT_ADMIN]: 'SADMIN'
};
